import { API_URL } from "../Config/config.js";
import axiosInstance from './axiosInstance.js';


const getStateList = async (params) => {
  try {
    const response = await axiosInstance.get(API_URL + "areas/state", { params }); 
    return {
      status: true,
      data: response.data.data.state,
    };
  } catch (err) {
    return {
      status: false,
      message: err.response.data.message,
      code: err.response.data.code,
    };
  }
};

const getDistrictList = async (params) => {
    try {
      const response = await axiosInstance.get(API_URL + "areas/district", { params }); 
      return {
        status: true,
        data: response.data.data.data,
      };
    } catch (err) {
      return {
        status: false,
        message: err.response.data.message,
        code: err.response.data.code,
      };
    }
  };

export default {
    getStateList,
    getDistrictList,
}